import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { environment } from '@environments/environment';
import { PaginatedReviewsResponse } from '@services/reviews/models/paginated-reviews-response';
import { AverageGrade } from '@shared/services/reviews/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReviewsService extends ApiServiceBase<unknown> {
  constructor() {
    super(
      `reviews/network/${environment?.integrations?.fournierWebservice?.network ?? '280'}`,
      'reviews',
      'fournierWebservice'
    );
  }

  getAverageGrade(storeUuid: string): Observable<AverageGrade> {
    return this.get(`averageGrade`, { storeUuid }, { cacheExpirationTime: 600 }) as Observable<AverageGrade>;
  }

  getReviewsByStore(storeUuid: string): Observable<PaginatedReviewsResponse> {
    return this.get('', { storeUuid }, { cacheExpirationTime: 600 }) as Observable<PaginatedReviewsResponse>;
  }
}
